<template>
    <div>
        <!-- Main Content -->
        <div class="main-block request-management">
             <Breadcrumbs />
            <div class="div col-12 p-0 d-flex align-items-start">
                <h4 class="">{{ $t('title.Inbox') }}</h4>
            </div>
            <div class="scrollable-block">
                <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">

                    <crud-table :columns="columns" :list-url="listUrl" ref="application-table"
                        v-on:refresh="resetFilter">
                        <template slot>
                            <b-button variant="primary" @click="$router.go(-1)">
                                <b-icon icon="arrow-left" class="icon-style"></b-icon>
                            </b-button>
                        </template>

                        <template #cell(actions)="{ item }">
                            <b-button variant="light" @click="openModal(item)">
                                <b-icon variant="primary" icon="eye" class="icon-style"></b-icon>
                            </b-button>
                        </template>

                    </crud-table>
                </div>
            </div>
        </div>

        <!-- Fullscreen Modal -->
        <div class="modal fade" :id="'fullscreen-modal'" role="dialog" :aria-labelledby="'fullscreen-modal-label'"
            :aria-hidden="!showPopup">
            <div class="modal-dialog modal-fullscreen modal-dialog-centered custom-modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="fullscreen-modal-label">{{ $t('title.view_details') }}</h5>
                    </div>
                    <div class="modal-body">
                        <!-- Display selected item details -->
                        <div v-if="selectedItem">
                            <h5>{{ selectedItem.subject }}</h5>
                            <p><strong>{{ $t('title.date') }}:</strong> {{ formatDate(selectedItem.receivedDateTime) }}
                            </p>
                            <p><span v-html="selectedItem.body.content"></span>
                            </p>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                @click="closeModal">
                                <span aria-hidden="true">close</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Modal
} from "bootstrap";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

const FILTER_FORM = {
    roles: null,
    statuses: null,
};
const COLUMN_STATE = (self) => [
    {
        key: 'sender.emailAddress.name',  // Adjusted to fetch the sender's name
        label: self.$t('title.from'),
        sortable: true
    },
    {
        key: 'toRecipients[0].emailAddress.name',  // Adjusted to fetch the first recipient's name
        label: self.$t('title.to'),
        sortable: true
    },
    {
        key: 'subject',
        label: self.$t('title.subject'),
        sortable: true
    },
    {
        key: 'actions',
        label: self.$t('title.actions')
    }
];


export default {
    data() {
        return {
            operation: '',
            query: {
                page: 1,
                perPage: 10,
            },
            pagination: {
                total: 0,
            },
            integrations: [],
            filters: { ...FILTER_FORM },
            showPopup: false,
            modalInstance: null,
            selectedItem: null,  // To store selected item for modal
            visibleFields: {},
            submenuItems: []
        };
    },
    components: { Breadcrumbs },
    mounted() {
        if(this.$route.query.subject) {
            this.$refs['application-table'].handleCustomSearch(this.$route.query.subject);
        }
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleString(this.$i18n.locale);  // Uses locale from i18n
        },
        handleFilter() {
            // Reset pagination when filters change
            this.query.page = 1;

            // Apply the filter and pass filters to the table's handleFilter method
            this.$refs['application-table'].handleFilter({ filters: this.filters });

        },
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.query.page = 1;
        },
        redirectToHome(item) {
            this.$router.push('/home');
        },
        openModal(item) {
            this.selectedItem = item;
            this.showPopup = true;
            // Create modal instance using Bootstrap Modal API
            const modal = new Modal(document.getElementById('fullscreen-modal'));
            modal.show();
        },

        closeModal() {
            this.showPopup = false;
            const modal = new Modal(document.getElementById('fullscreen-modal'));
            modal.hide();
        }

    },
    computed: {
        listUrl() {
            const id = this.$route.params.id || '';
            return `admin/getUserMailBox/${id}`;
        },
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>

<style scoped>
.custom-modal-dialog {
    max-width: 80%;
    margin-top: 2%;
}
</style>
